import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=1f197ec7&scoped=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"
import style0 from "./SideBarMenu.vue?vue&type=style&index=0&id=1f197ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f197ec7",
  null
  
)

export default component.exports